import React from 'react'
import { Field } from 'redux-form'
import { InputCheckbox, CheckboxLabel, CheckBoxContainer } from './styles'

const renderCheckboxItem = props => {
  const inputValue = props.input.value
  return (
    <InputCheckbox
      {...props}
      onChange={e => {
        const arr = [...inputValue]
        if (e.target.checked) {
          arr.push(props.typeValue)
        } else {
          arr.splice(arr.indexOf(props.typeValue), 1)
        }
        props.input.onChange(arr)
        props.setWeekDayRef(e.target)
      }}
      value={props.input.value}
      type="checkbox"
    />
  )
}

function CheckboxItem(props) {
  return (
    <CheckBoxContainer>
      <Field component={renderCheckboxItem} {...props} />
      <CheckboxLabel>{props.label}</CheckboxLabel>
    </CheckBoxContainer>
  )
}

export default CheckboxItem



// WEBPACK FOOTER //
// ./src/app/modules/FilterByWeekDays/CheckboxItem.js